<div class="ontario-alert ontario-alert--error">
  <div class="ontario-alert__header">
    <div class="ontario-alert__header-icon">
      <mat-icon aria-hidden="true">error</mat-icon>
    </div>
    <h2 class="ontario-alert__header-title ontario-h4">Error Authorizing Current User</h2>
    <div class="close-alert">
      <button mat-icon-button matTooltip="Close" aria-label="Close" (click)="close()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="ontario-alert__body">
    <p>We're having trouble authorizing your account. This may be a temporary issue. Please try the following:</p>
    <ul>
      <li>Refresh your browser</li>
      <li>Clear your cache and cookies</li>
      <li>Try signing out and signing back in</li>
    </ul>
    <p>
      If the problem persists, contact IT Support at
      <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      and reference Error ID: <strong>{{ errorId }}</strong
      >.
    </p>
  </div>
</div>
